import { lazy, Suspense, useRef } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useAtomValue } from 'jotai';

import { Main, Wrapper } from './content.styles';

import ErrorBoundary from '../../error_boundary';
import LoadingText from '../../loading_text';
import ScrollToTop from '../../scroll_to_top';
import Title from '../../title';
import AcceptTermsAndConditionsPage from './home/card_subscription/accept_terms_and_conditions';
import AppConsentsPage from './home/card_subscription/app_consents';
import OffersPage from './home/card_subscription/offers';
import RewardReceivedPage from './home/card_subscription/reward_received';
import RewardsPage from './home/card_subscription/rewards';
import TermsAndConditionsPage from './home/card_subscription/terms_and_conditions';

import { vendorCardState } from '../../../store';

const HomePage = lazy(() => import('./home'));
const PlacesPage = lazy(() => import('./places'));
const InboxPage = lazy(() => import('./inbox'));
const ProductsPage = lazy(() => import('./products'));
const ProfilePage = lazy(() => import('./profile'));
const CameraPage = lazy(() => import('./camera'));
const RedeemPage = lazy(() => import('./redeem'));
const MorePage = lazy(() => import('./more'));

const PWAPopover = lazy(() => import('./pwa_popover'));

export default function Content() {
  const wrapper = useRef<HTMLDivElement>(null);

  const card = useAtomValue(vendorCardState);

  const hasTermsAndConditions = Boolean(card.terms_and_conditions);

  return (
    <>
      <ErrorBoundary fallback={null}>
        <Suspense fallback={null}>
          <PWAPopover />
        </Suspense>
      </ErrorBoundary>
      <Wrapper ref={wrapper}>
        <Title />
        <ScrollToTop wrapper={wrapper} />
        <Main>
          <Suspense fallback={<LoadingText />}>
            <Routes>
              <Route element={<HomePage />} path="" />
              <Route element={<Navigate to="/places" />} path="map/*" />
              <Route element={<InboxPage />} path="inbox/*" />
              <Route element={<ProfilePage />} path="profile/*" />
              <Route element={<CameraPage />} path="camera/*" />
              <Route element={<RedeemPage />} path="redeem/*" />
              <Route element={<OffersPage />} path="offers/*" />
              <Route element={<PlacesPage />} path="places/*" />
              <Route element={<ProductsPage />} path="products/*" />
              <Route element={<RewardsPage />} path="rewards/*" />
              <Route element={<RewardReceivedPage />} path="reward_received/*" />
              <Route element={<AppConsentsPage />} path="app_consents/*" />
              {hasTermsAndConditions ? (
                <Route
                  element={<AcceptTermsAndConditionsPage />}
                  path="accept_terms_and_conditions/*"
                />
              ) : null}
              {hasTermsAndConditions ? (
                <Route element={<TermsAndConditionsPage />} path="terms_and_conditions/*" />
              ) : null}
              <Route element={<MorePage />} path="more/*" />
              <Route element={<Navigate to="/" />} path="*" />
            </Routes>
          </Suspense>
        </Main>
      </Wrapper>
    </>
  );
}
